import React, { memo, lazy, Suspense } from 'react';
import { Row, Col, Modal, Button, Card, ListGroup, Badge, Container, Spinner, Image } from 'react-bootstrap';
import { defaultMapProps, mapApiKey } from "services/stillageDashboard";
import FalconLightBoxGallery from 'components/common/FalconLightBoxGallery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import MapWrapper from '../MapWrapper';
const GoogleMapReact = lazy(() => import('google-map-react'));

const MapIcon = memo(() => {
    return (
        <div style={{
            display: 'inline-flex',
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.5rem',
            position: "relative",
            textShadow: "0 0 3px #000000ff",
        }}>📍</div>
    )
});

const StillageHistoryModal = ({ showModal, setShowModal, modalData, stillageNo, loading }) => {
    return (
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            centered
            size="xl"
            animation={false}
            scrollable
            restoreFocus={false}
            enforceFocus={false}
            autoFocus={false}>
            <Modal.Header closeButton>
                <Modal.Title>Stillage Details - {stillageNo || ''}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    {loading ?
                        <div className='justify-content-center d-flex w-100 my-5'>
                            <Spinner animation="border" role="status" variant='primary' />
                        </div>
                        : (modalData && showModal ? (
                            modalData.map((item, index) => {
                                // All attachments are images or PDF files for certificates
                                const photos = item.photos?.filter(x => !x.path?.toLowerCase().includes('pdf'));
                                const files = item.photos?.filter(x => x.path?.toLowerCase().includes('pdf'));
                                return (
                                    <Row key={`${item.stillageID}_${index}`}>
                                        <Col className='d-flex justify-content-start ps-2' sm={6}>
                                            <ListGroup className='w-100' variant="flush">
                                                <Card className='m-2 p-1'>
                                                    <Card.Title className='p-2'>
                                                        <Badge className='me-1 text-light' bg="dark">{item.statusName}</Badge>
                                                        <Badge bg="secondary">{dayjs(item.statusDateTime).format('DD/MM/YYYY')}</Badge>
                                                    </Card.Title>
                                                    <Card.Body>
                                                        <ListGroup variant="flush">
                                                            <ListGroup.Item>
                                                                <Row>
                                                                    <Col className='d-flex justify-content-start'>
                                                                        <strong>Customer Name:</strong>
                                                                    </Col>
                                                                    <Col className='d-flex justify-content-end'>
                                                                        {item.customerName || 'N/A'}
                                                                    </Col>
                                                                </Row>
                                                            </ListGroup.Item>
                                                            <ListGroup.Item>
                                                                <Row>
                                                                    <Col className='d-flex justify-content-start'>
                                                                        <strong>Stillage ID:</strong>
                                                                    </Col>
                                                                    <Col className='d-flex justify-content-end'>
                                                                        {item.fbStillageID}
                                                                    </Col>
                                                                </Row>
                                                            </ListGroup.Item>
                                                            <ListGroup.Item>
                                                                <Row>
                                                                    <Col className='d-flex justify-content-start'>
                                                                        <strong>Notes:</strong>
                                                                    </Col>
                                                                    <Col className='d-flex justify-content-end'>
                                                                        {item.notes ?? 'N/A'}
                                                                    </Col>
                                                                </Row>
                                                            </ListGroup.Item>
                                                            {item.statusName === 'Certified' ?
                                                                <>
                                                                    <ListGroup.Item>
                                                                        <Row>
                                                                            <Col className='d-flex justify-content-start'>
                                                                                <strong>Certificate Start:</strong>
                                                                            </Col>
                                                                            <Col className='d-flex justify-content-end'>
                                                                                {item.certStartDate ? dayjs(item.CertStartDate).format('DD/MM/YYYY') : 'N/A'}
                                                                            </Col>
                                                                        </Row>
                                                                    </ListGroup.Item>
                                                                    <ListGroup.Item>
                                                                        <Row>
                                                                            <Col className='d-flex justify-content-start'>
                                                                                <strong>Certificate End:</strong>
                                                                            </Col>
                                                                            <Col className='d-flex justify-content-end'>
                                                                                {item.certEndDate ? dayjs(item.CertEndDate).format('DD/MM/YYYY') : 'N/A'}
                                                                            </Col>
                                                                        </Row>
                                                                    </ListGroup.Item>
                                                                    <ListGroup.Item>
                                                                        <Row>
                                                                            <Col className='d-flex justify-content-start'>
                                                                                <strong>Uploaded By:</strong>
                                                                            </Col>
                                                                            <Col className='d-flex justify-content-end'>
                                                                                {item.uploadedBy ?? 'N/A'}
                                                                            </Col>
                                                                        </Row>
                                                                    </ListGroup.Item>
                                                                </> :
                                                                <ListGroup.Item>
                                                                    <Row>
                                                                        <Col sm={2} className='d-flex justify-content-start'>
                                                                            <strong>Map:</strong>
                                                                        </Col>
                                                                        <Col className='d-flex justify-content-end'>
                                                                            {item.long && item.lat && showModal ?
                                                                                <Suspense fallback={<Spinner animation="border" role="status" variant='primary' />}>
                                                                                    <MapWrapper height={'200px'} width={'100%'}>
                                                                                        <GoogleMapReact
                                                                                            bootstrapURLKeys={{ key: mapApiKey }}
                                                                                            defaultCenter={{
                                                                                                lng: item.long ?? defaultMapProps.center.lng,
                                                                                                lat: item.lat ?? defaultMapProps.center.lat
                                                                                            }}
                                                                                            defaultZoom={defaultMapProps.zoom + 6}
                                                                                        >
                                                                                            <MapIcon
                                                                                                lat={item.lat}
                                                                                                lng={item.long}
                                                                                            />
                                                                                        </GoogleMapReact>
                                                                                    </MapWrapper>
                                                                                </Suspense>
                                                                                :
                                                                                'No location data available'
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                </ListGroup.Item>
                                                            }
                                                        </ListGroup>
                                                    </Card.Body>
                                                </Card>
                                            </ListGroup>
                                        </Col>
                                        <Col className='d-flex justify-content-end ps-2' sm={6}>
                                            {photos && photos.length > 0 && showModal ? (
                                                <FalconLightBoxGallery images={photos.map(x => x.path)}>
                                                    {setImgIndex => (
                                                        <Container>
                                                            <Row>
                                                                {photos.map((photo, idx) => (
                                                                    <Col sm={4} key={photo.path ?? idx}>
                                                                        <div className='shadow m-2'>
                                                                            <Image
                                                                                fluid
                                                                                loading='lazy'
                                                                                rounded
                                                                                src={photo.path}
                                                                                alt={`Stillage Photo ${idx + 1}`}
                                                                                className="d-block position-relative"
                                                                                onClick={() => setImgIndex(idx)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                ))}
                                                            </Row>
                                                        </Container>
                                                    )}
                                                </FalconLightBoxGallery>
                                            ) : <></>}
                                            {files && files.length > 0 && showModal ?
                                                <Container>
                                                    <Row>
                                                        {files.map((file, idx) => (
                                                            <Col sm={12} key={file.path ?? idx}>
                                                                <div className='shadow m-2'>
                                                                    <div className='p-1'>
                                                                        <a href={file.path} target='_blank' rel="noreferrer">
                                                                            <FontAwesomeIcon icon="eye" className="text-600 float-end m-2" />
                                                                        </a>
                                                                    </div>
                                                                    <iframe src={file.path} className="w-100" />
                                                                </div>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Container> :
                                                <></>
                                            }
                                        </Col>
                                        {index < modalData.length - 1 && <div className='d-flex justify-content-center'><hr className='my-3 text-black-25 w-75' /></div>}
                                    </Row>
                                )
                            })
                        ) : (
                            <div className='h-100 text-center align-middle my-1'>No data</div>
                        ))}
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

StillageHistoryModal.propTypes = {
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func,
    modalData: PropTypes.array,
    stillageNo: PropTypes.number,
    loading: PropTypes.bool
};

export default memo(StillageHistoryModal);